import { useLocation } from "react-router-dom";
import NotFoundPage from "./NotFoundPage";
import NewDesignNotFoundPage from "@/custolink-newdesign/pages/NotFoundPage";
import { isNewDesign } from "@/custolink-newdesign/flag";
import { isAssetFrontendNewDesign } from "@/custolink-views/asset_frontend/redesigns/assetFrontendDesign";

/**
 * Element for the "*" catch-all routes in OrganisationAllRoutes.tsx. Picks the
 * new design's not-found page unless the relevant switch opts out, same gate
 * as RouteErrorBoundary. Under /admin (both the org admin area and the
 * cp.* control panel, which also lives at /admin - see appConfig's
 * authenticatedControlpanelEntryPath) that is the admin switch; everywhere
 * else - the public asset-frontend tree - it is the asset-frontend switch,
 * so a customer who opted out of the asset redesign never sees the admin
 * area's new-design 404 just because ?new_design hasn't been touched.
 */
export default function RouteNotFound() {
  const location = useLocation();
  const isAdminArea = location.pathname.startsWith("/admin");
  const newDesign = isAdminArea ? isNewDesign() : isAssetFrontendNewDesign();

  if (newDesign) {
    return <NewDesignNotFoundPage />;
  }
  return <NotFoundPage />;
}
